import React  , { Component } from 'react'

import {  HomeSlider,
          HomeTitle       } from '../../Components/UI/UI'

import { getWeather, asyncgetWeather } from "../../Utility/Utility";

import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'

import "./TermsOfUse.css"

class TermsOfUse extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
        var weather = response[0];
     

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                        
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}
  
  render(){
    return(
      <div className="page align-left page-TermsOfUse">
        <Menu />
          <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
            
            <div class="container">
              <HomeTitle>
                Terms of Use
              </HomeTitle>
              <h3>General</h3>
              <p>
              The Israeli Ministry of Tourism (hereinafter- the Ministry) offers the information on this website (hereinafter- the service) subject to your acceptance, with no amendments whatsoever, of the terms, conditions and notifications contained herein. By using the Service you signify your agreement to all such terms, conditions and notifications. Please read these Terms of Use carefully before using the Service. If you do not agree to all these terms, you may not use the Service. The term “User” as follows shall mean each person who establishes or accesses a connection to the service.
              </p>
              <h3>
              Liability
              </h3>
              <p>
              The information provided to User is provided for his convenience only. Information that concerns third parties should be verified with the service providers themselves before making a decision based on the information shown.
              </p>
              <p>
              It is emphasized that the businesses whose details are provided in the Service are not supervised or reviewed by the Ministry and are not under its responsibility, and the Ministry therefore is not responsible in any way for the service provided to any visitor, including the quality and nature of the physical facilities or the service, the prices charged, the visitor’s satisfaction, etc.
              
              The Ministry shall not be held liable for any damage caused to User and/or to any visitor in the course of any visit or use made based on the information provided to him/her by the Service.
              
              The information provided to User informs of the existence per se of the businesses (attractions, accommodation, events, etc.) and is not in any way a specific recommendation to use a particular business. Full responsibility for the service is imposed on the service provider.
              
              The information provided on the Service may not be construed as endorsement, approval, recommendation or favoring of the use of a particular service or of a visit to a particular site and/or business.
              
              The Ministry shall not be held liable for the suitability of the Service to User’s needs. Furthermore, the Ministry shall not be held liable for errors or mistakes in the information provided to User which was not produced by the Ministry but is received from third parties..
              
              User alone is responsible for the way in which he/she uses the Service.
              
              The Ministry shall not be held liable for any damage caused to User or to any third party as a direct or indirect result of using the Service, including damage caused due to the use of software applications downloaded directly through the Service or activated as a result of the use of the Service, including Java, JavaScript and ActiveX.
              
              For purposes of this section, “The Ministry” includes its employees and representatives.
              </p>
              <h3>Links</h3>
              <p>
              As part of the Service, the Service may provide links to other websites. The following conditions apply to the use of those links, without derogating from the other conditions in these Terms of Use. The links are provided solely for the convenience of User. Regarding links to external sites which are not owned by the State of Israel (third party sites), unless otherwise stipulated on this Site, no legal or commercial relationship exists between the Ministry and the owners of third party sites, and the Ministry has no control over or right to material found on those sites.
              
              The Ministry is not responsible for the content of third party sites and/or for information on commercial or noncommercial products or services offered on them, including the nature or quality thereof. It is recommended to check the information with the service providers or with another relevant party. Links to third party sites may not be construed as endorsement, approval, recommendation or favoring by the State of Israel of those linked-to sites, including documents and other material found on them, of the operators of said sites and of the products or services presented and/or offered on them. At the time each link was included in this Service, the information contained on the linked-to site was found to be compatible with the purposes of the Service and the link itself was functional. However, it is possible that with the passage of time changes have occurred in the linked-to site. If User feels that the linked-to site or material is inappropriate, or if User finds that the link is no longer operational, he/she is requested to inform the Ministry via email at: NitsanI@tourism.gov.il
              </p>
              <h3>
              Deals/packages
              </h3>
              <p>
              The Ministry serves as an information channel and is not responsible whatsoever for the packages advertised herein by third commercial parties.
              
              Any and all purchases of packages appearing on this page shall not take place on the Ministry’s platform and the purchase shall be performed on the platform of the entity who is advertising the package. Full responsibility for the service is imposed on the service provider and not the Ministry of Tourism.
              
              The packages are neither supervised nor reviewed by the Ministry and are not under its responsibility, therefore it is recommended to verify the information with the service providers themselves before making a decision based on the information shown.
              </p>
              <h3>
              Copyright
              </h3>
              <p>
              The copyrights of the website and its content belong to the Ministry. Subject to copyright law, User may not copy, redistribute, retransmit or publish protected material, without the prior written consent of the Ministry.
              </p>
              <h3>
              Contacting the Ministry
              </h3>
              <p>
              Any question regarding this Service and other questions relating to the Ministry’s sphere of activity may be addressed directly to the Ministry by email at: NitsanI@tourism.gov.il
              
              </p>
              <h3>
              Official Publications of the State of Israel
              </h3>
              <p>
              In the event of a conflict or inconsistency between material published in the Service and material appearing in official written publications of the State of Israel, only the material contained in such official publications shall be deemed correct.
              </p>
              <h3>
              Copyright Infringement Notification
              </h3>
              <p>
              If you believe your copyright-protected work was posted on this page without authorization, you may submit a copyright infringement notification by e-mail to nitsani@tourism.gov.il. Notification and requests should be submitted by the copyright owner or an agent authorized to act on the owner’s behalf.
              </p>
              <h3>
              Defamation
              </h3>
              <p>
              If you believe that any content uploaded, posted or published on this website is defamatory, please submit your notification by e-mail to NitsanI@tourism.gov.il.
              </p>
          </div>

          
        <Footer />
      </div>
    )
  }

}



export default TermsOfUse


// WEBPACK FOOTER //
// ./src/Pages/TermsOfUse/TermsOfUse.js